module.exports = __webpack_public_path__ + "media/dz_bodzavirag_k.7fb7737f.mp3";